export {Label, ILabelProps} from "./Label";